<template>
    <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
            <!-- Login v1 -->
            <b-card class="mb-0">
                <b-link class="brand-logo" :to="{ name: 'welcome' }">
                    <vuexy-logo />
                </b-link>

                <b-card-title class="mb-1" align="center">
                    Bienvenido! 👋
                </b-card-title>
                <!-- Alert -->
                <div>
                    <b-alert variant="warning" show>
                        <div
                            class="alert-body"
                            style="color:white; textAlign: justify"
                        >
                            Con LukiPlay disfrutarás del mejor entretenimiento
                        </div>
                    </b-alert>
                </div>

                <!-- form -->
                <validation-observer ref="loginForm" #default="{ invalid }">
                    <b-form
                        class="auth-login-form mt-2"
                        @submit.prevent="login"
                    >
                        <!-- email -->
                        <b-form-group label-for="email" label="Email">
                            <validation-provider
                                #default="{ errors }"
                                name="Email"
                                rules="required|email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="userEmail"
                                    name="login-email"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder=""
                                    autofocus
                                    trim
                                    class="text-white"
                                />
                                <small class="text-danger">{{
                                    errors[0]
                                }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- password -->
                        <b-form-group>
                            <div class="d-flex justify-content-between">
                                <label for="password">Password</label>
                                <b-link
                                    :to="{
                                        path: `/forgot-password/${userEmail}`,
                                        params: { email: userEmail }
                                    }"
                                >
                                    <small
                                        style="font-size: 14px;"
                                        class="text-warning"
                                        >Olvido su contraseña?</small
                                    >
                                </b-link>
                            </div>
                            <validation-provider
                                #default="{ errors }"
                                name="Password"
                                rules="required"
                            >
                                <b-input-group
                                    class="input-group-merge"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                >
                                    <b-form-input
                                        id="password"
                                        v-model="password"
                                        :type="passwordFieldType"
                                        class="form-control-merge text-white"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        name="login-password"
                                        placeholder="Password"
                                    />

                                    <b-input-group-append is-text>
                                        <feather-icon
                                            class="cursor-pointer"
                                            :icon="passwordToggleIcon"
                                            @click="togglePasswordVisibility"
                                        />
                                    </b-input-group-append>
                                </b-input-group>
                                <small class="text-danger">{{
                                    errors[0]
                                }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- checkbox -->
                        <b-form-group>
                            <b-form-checkbox
                                id="remember-me"
                                v-model="status"
                                name="checkbox-1"
                            >
                                Recuerdame
                            </b-form-checkbox>
                        </b-form-group>

                        <!-- submit button -->
                        <b-button
                            v-if="!isLoading"
                            variant="secondary"
                            type="submit"
                            block
                            :disabled="invalid"
                            style="color: #004e7c"
                        >
                            INICIAR SESIÓN
                        </b-button>

                        <b-button
                            v-if="isLoading"
                            variant="secondary"
                            disabled
                            block
                        >
                            <b-spinner small />
                            Cargando...
                        </b-button>
                    </b-form>
                </validation-observer>

                <b-card-text class="text-center mt-2 text-white">
                    <span>Nuevo en la plataforma? </span>
                    <b-link :to="{ name: 'auth-register' }">
                        <span class="text-warning">&nbsp;REGISTRATE</span>
                    </b-link>
                </b-card-text>
            </b-card>
            <!-- /Login v1 -->
        </div>

        <!-- Modal -->
        <b-modal
            id="modal-login-session"
            ok-only
            ok-variant="danger"
            ok-title="Cerrar"
            modal-class="modal-danger"
            centered
            size="xl"
            title="Sesiones"
            v-model="modalShow"
        >
            <login-sessions :userData="userSession" />
        </b-modal>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BSpinner,
    BAlert,
    VBTooltip,
    BModal,
    VBModal,
    BImg
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import LoginSessions from "./LoginSessions.vue";

export default {
    directives: {
        "b-tooltip": VBTooltip
    },
    components: {
        BButton,
        BForm,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BLink,
        VuexyLogo,
        BCardText,
        BInputGroup,
        BSpinner,
        BInputGroupAppend,
        BFormCheckbox,
        BAlert,
        ValidationProvider,
        ValidationObserver,
        ToastificationContent,
        BModal,
        VBModal,
        BImg,
        LoginSessions
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: "",
            password: "",
            userEmail: "",
            device_name: "",
            sideImg: require("@/assets/images/pages/login-trantor.png"),
            required,
            email,
            isLoading: false,
            userSession: {},
            modalShow: false
        };
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === "password"
                ? "EyeIcon"
                : "EyeOffIcon";
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === "dark") {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require("@/assets/images/pages/login-trantor.png");
                return this.sideImg;
            }
            return this.sideImg;
        }
    },
    mounted() {
        this.userEmail =
            this.$route.params.email != "undefined"
                ? this.$route.params.email
                : null;
    },
    methods: {
        login() {
            this.$refs.loginForm.validate().then(success => {
                if (success) {
                    this.isLoading = true;
                    this.device_name = this.consultarDevice();
                    this.$http
                        .post("/api/auth/login", {
                            email: this.userEmail,
                            password: this.password,
                            device_name: this.device_name
                        })
                        .then(response => {
                            const msn = response.data.msm;
                            const session = response.data.session;

                            if (session) {
                                this.userSession = response.data.userData;
                                this.isLoading = false;
                                this.modalShow = true;
                                return false;
                            }

                            if (msn == "SI") {
                                this.addTrack();

                                useJwt.setToken(response.data.accessToken);

                                useJwt.setRefreshToken(
                                    response.data.refreshToken
                                );

                                localStorage.setItem(
                                    "userData",
                                    JSON.stringify(response.data.userData)
                                );

                                this.$ability.update(
                                    response.data.userData.ability
                                );

                                this.isLoading = false;

                                this.$router.push("/home");

                            } else {
                                this.isLoading = false;
                                this.$swal({
                                    title: "Error",
                                    customClass: {
                                        title: "text-secondary",
                                        confirmButton: "btn btn-secondary"
                                    }
                                });
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.$swal({
                                title: "Notificación",
                                text: error.response.data.error
                                    ? error.response.data.error
                                    : error.message,
                                customClass: {
                                    title: "text-secondary",
                                    confirmButton: "btn btn-secondary"
                                }
                            });
                        });
                }
            });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon
                }
            });
        },
        consultarDevice() {
            var browser = "";
            var browserVersion = 0;
            if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = "Opera";
            } else if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                browser = "MSIE";
            } else if (/Navigator[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = "Netscape";
            } else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = "Chrome";
            } else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = "Safari";
                /Version[\/\s](\d+\.\d+)/.test(navigator.userAgent);
                browserVersion = new Number(RegExp.$1);
            } else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = "Firefox";
            }
            if (browserVersion === 0) {
                browserVersion = parseFloat(new Number(RegExp.$1));
            }
            return browser + "*" + browserVersion;
        },
        async addTrack() {
            this.$gtag.event("login", {
                event_category: "authentication",
                event_label: "authentication login",
                value: 1
            });
        }
    }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
}

@media screen and (max-width: 680px) {
    .footer {
        display: none;
    }
}
</style>
